import { useDraggable } from '@dnd-kit/core';
import { CancelOutlined } from '@mui/icons-material';
import { Slide } from '@mui/material';
import React, { CSSProperties, useState } from 'react';

import { DispatchShipmentFragmentProps } from './DispatchShipmentFragment.props';
import { ContainerGrid, IconButtonWrapper, DraggableDiv } from './DispatchShipmentFragment.styles';
import { ButtonSizeProps } from '../../../../../components/atoms/Button';
import { COLORS } from '../../../../../configs/colors';
import { Dispatch } from '../../../../Shipments/Dispatch';

export const DispatchShipmentFragment: React.FC<DispatchShipmentFragmentProps> = ({
  data,
  dispatchData,
  onDispatch,
}) => {
  const [grabbing, setGrabbing] = useState(false);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: 'dispatch-shipment-fragment',
  });

  const style: CSSProperties = {
    transform: `translate3d(${transform?.x}px, ${transform?.y}px, 0)`,
    position: 'absolute',
    zIndex: 100
  };

  return (
    <Slide
      direction="left"
      in={dispatchData.openFragment}
      timeout={500}
      mountOnEnter
      unmountOnExit
      onExited={() => onDispatch({ ...dispatchData, exited: true })}
    >
      <ContainerGrid ref={setNodeRef} style={style} onDragStart={() => setGrabbing(true)} onDragEnd={() => setGrabbing(false)}>
        <DraggableDiv {...listeners} {...attributes} grabbing={grabbing}>
          Click to drag
        </DraggableDiv>
        <IconButtonWrapper
          aria-label="close"
          onClick={() =>
            onDispatch({
              openFragment: false,
              serviceId: 0,
              mainLocation: '',
              mainLocationNodeId: 0,
              isFromServiceEdit: true,
            })
          }
        >
          <CancelOutlined fontSize={ButtonSizeProps.Medium} htmlColor={COLORS.Orange} />
        </IconButtonWrapper>
        <Dispatch
          dispatchData={{
            ...dispatchData,
            subLocationNodeId: data.subLocationNodeId,
            primaryAllocationNodeId: data.primaryAllocation?.node?.id || 0,
            secondaryAllocationNodeId: data.secondaryAllocation?.node?.id || 0,
          }}
          onDispatch={onDispatch}
        />
      </ContainerGrid>
    </Slide>
  );
};